import { Component, OnInit, AfterViewInit, OnDestroy } from "@angular/core";
import { CclDrawerService, CclNavbarFooterService, CclMessageService } from "certain-common-library";
import { SharedService } from "../../../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../../../modules/shared/services/catalog.service";
import { LocalDataService } from "../../../../../../modules/shared/services/local-data.service";
import { FlashMessagesService } from "angular2-flash-messages";
import { cloneDeep } from "lodash";
import { Subscription } from "rxjs";
import { UnsavedChangesDeactivate } from "../../../../can-deactivate";
@Component({
    selector: "edit-filter",
    templateUrl: "./edit-label.view.html",
    providers: []
})
export class EditFilterLabelView extends UnsavedChangesDeactivate implements AfterViewInit, OnInit, OnDestroy {
    subscription: Subscription;
    generalSession: any;
    generalSessionConfig: any;
    constructor(
        private drawerService: CclDrawerService,
        private _flashMessagesService: FlashMessagesService,
        public sharedService: SharedService,
        private catalogService: CatalogService,
        private navbarFooterService: CclNavbarFooterService,
        private messageService: CclMessageService,
        private localDataService: LocalDataService
    ) {
        super(sharedService);
        this.subscription = this.messageService
            .getMessage()
            .subscribe((message) => this.saveLabel(message));
    }

    catalogLayoutConfig: any = {};
    editabeJSON: any = null;
    defaultJSON: any = null;
    ddfText = "{@ddf.sessionDetails@}"
    ngOnInit() {
        this.drawerService.closeMessage = null;
        this.catalogLayoutConfig = JSON.parse(this.sharedService.setup.layoutConfig);
        this.sharedService.currentLayoutSection = "edit-label";
        this.generalSession = this.sharedService.configs[this.sharedService.configTypes.SESSION.general];
        this.generalSessionConfig = JSON.parse(this.generalSession.config);
        if(!('customizedError' in this.generalSessionConfig.catalogConfig)) {
            this.generalSessionConfig.catalogConfig.customizedError = `This session {@ddf.sessionDetails@} is conflicting with other session's in same time intervals`
        }
        this.getJSON()
    }

    getJSON() {
        let jsonPath =
            `/accounts/${this.sharedService.event.fileDir}session_catalog_${this.sharedService.catalogUUID}.json` +
            "?random=" +
            new Date().getTime();
        this.catalogService.getJSONService(jsonPath).subscribe((data)=> {
            this.editabeJSON = data.body
            this.getDefaultJSON();
        }, (err) => {
            this.getDefaultJSON();
        })
    }

    getDefaultJSON() {
        let jsonPath = './assets/i18n/en.json'
        this.catalogService.getJSONService(jsonPath).subscribe((data)=> {
            this.defaultJSON = data.body
            if(this.editabeJSON == null) {
                this.editabeJSON = cloneDeep(this.defaultJSON);
            }
        })
    }

    saveLabel(message) {
        if (message.text == "save-label-setting" || message.text == "save-next-label-setting") {
            if(!this.generalSessionConfig.catalogConfig.customizedError.trim()) {
                this._flashMessagesService.show("Customized Error Message is a required field", {
                        cssClass: "alert-danger"
                });
                return
            }

            if(this.generalSessionConfig.catalogConfig.customizedError && !this.generalSessionConfig.catalogConfig.customizedError.includes(this.ddfText)) {
                this._flashMessagesService.show("Customized Error Message must have session details ddf in it.", {
                        cssClass: "alert-danger"
                });
                return
            }
            const jsonBlob = new Blob([JSON.stringify(this.editabeJSON)], { type: "application/json" });
            const formData: FormData = new FormData();
            formData.append("file", jsonBlob, `session_catalog_${this.sharedService.catalogUUID}.json`);
                this.catalogService.saveJSON(formData).subscribe(() => {
                    this._flashMessagesService.show("Edit Labels saved successfully.", {
                        cssClass: "alert-success"
                    });
                    if (message.text == "save-next-label-setting") {
                        this.sharedService.catalogNavigateHelper("admin", "catalog/add-setting/button-config");
                    }
                });
                this.generalSession.config = JSON.stringify(this.generalSessionConfig);
                this.catalogService.saveSetupConfig(this.generalSession).subscribe((resp) => {
                })

        }
    }

    ngAfterViewInit(): void {
        if (this.navbarFooterService.navbar != null && this.navbarFooterService.navbar.rightNavbarItems != null) {
                this.navbarFooterService.navbar.rightNavbarItems[0].label =
                    "NEXT STEP: Edit Buttons & Icons";
            this.navbarFooterService.navbar.rightNavbarItems[1].message = "save-label-setting";
            this.navbarFooterService.navbar.rightNavbarItems[2].message = "save-next-label-setting";
        }
        this.messageService.sendMessage("update-publish-button");
    }

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }
}
